import useTranslation from 'customHooks/translate';

const InvoiceDetailsInfo = ({ invoice }) => {
  const translation = useTranslation();

  return (
    <div className="flex h-full flex-col gap-[10px] px-[16px] py-[24px] md:border-b md:border-l md:border-b-[#f5f7f9] md:border-l-[#f5f7f9]">
      <div className="flex h-max flex-col justify-between gap-[4px] rounded-[4px] bg-[#F5F7F9] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">
          {translation.InvoiceDetails.Total}
        </p>
        <div className="flex items-center gap-[6px]">
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            {translation.InvoiceDetails.TotalNet}:
          </p>
          <p className="text-[16px] font-normal text-[#1D1D1D]">
            {new Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(invoice.total || 0)}{' '}
            {invoice.currency}
          </p>
        </div>
        <div className="flex items-center gap-[6px]">
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            {translation.InvoiceDetails.Discount}:
          </p>
          <p className="text-[16px] font-normal text-[#1D1D1D]">
            {new Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(invoice.discount || 0)}{' '}
            {invoice.currency}
          </p>
        </div>
        <div className="flex items-center gap-[6px]">
          {invoice?.taxDetails?.map((taxDetail, index) => (
            <p
              key={index}
              className="text-[16px] font-medium text-[#1D1D1D]"
            >
              {taxDetail?.taxType}:
            </p>
          ))}
          {invoice?.taxDetails?.map((taxDetail, index) => (
            <p
              key={index}
              className="text-[16px] font-normal text-[#1D1D1D]"
            >
              {new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(taxDetail?.taxAmount || 0)}{' '}
              {invoice.currency}
            </p>
          ))}
        </div>
        <div className="flex items-center gap-[6px]">
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            {translation.reports.AllAmount}:
          </p>
          <p className="text-[16px] font-normal text-[#1D1D1D]">
            {new Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(invoice.summary || 0)}{' '}
            {invoice.currency}
          </p>
        </div>
      </div>
      <div className="flex h-max flex-col justify-between gap-[4px] rounded-[4px] bg-[#F5F7F9] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">
          {translation.reports.RemindAmount}
        </p>
        <p className="text-[16px] font-normal text-[#1D1D1D]">
          {new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(invoice.balance || 0)}{' '}
          {invoice.currency}
        </p>
      </div>
    </div>
  );
};

export default InvoiceDetailsInfo;
